import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';
import type { MeasurementsStats } from '@weft/api-definition';
import { VyIcon } from '@weft/icons';
import { validateNotEmptyArray } from '@weft/utils';
import { dayjs } from '@weft/utils';
import { saveAs } from 'file-saver';
import Papa from 'papaparse';
import React, { useCallback } from 'react';

type ExportToCsvButtonProps = {
  startDay: Date;
  endDay: Date;
  measurementsStats: MeasurementsStats[] | undefined;
} & ButtonProps;

export const ExportToCsvButton:React.FC<ExportToCsvButtonProps> = ({
  startDay,
  endDay,
  measurementsStats,
  ...buttonProps
}) => {
  const onExportClick = useCallback(() => {
    handleExportCsvClick(measurementsStats, startDay, endDay);
  }, [measurementsStats]);

  return (
    <Button
      variant="contained"
      size="medium"
      onClick={onExportClick}
      startIcon={<VyIcon icon="Download"/>}
      {...buttonProps}
    >
      Download
    </Button>
  );
};

function handleExportCsvClick(measurementsStats: MeasurementsStats[] | undefined, startDay: Date, endDay: Date) {
  validateNotEmptyArray(measurementsStats, 'measurementsStats');
  const measurementsToExport = measurementsStats.map(buildAggregatedMeasurementForCsv);
  const csv = Papa.unparse(measurementsToExport);
  const fileNameDayRange = formatDatesRange(startDay, endDay);

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const fileName = `Usage Report - ${fileNameDayRange}.csv`;

  saveAs(blob, fileName);
}

function formatDatesRange(startDay: Date, endDay: Date) {
  return dayjs(startDay).format('MM/DD') + ' To ' + dayjs(endDay).format('MM/DD');
}

function buildAggregatedMeasurementForCsv(measurementStat: MeasurementsStats) {
  return {
    'Day': measurementStat.day,
    'Customer': measurementStat.customer,
    'Product': measurementStat.product,
    'Sub Product': measurementStat.productVariant,
    'QTY': measurementStat.quantity,
  };
}